import React from 'react';
import { Row, Col, ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { IconBoxPanel } from 'components';
import './plans-calculator-styles.scss';
import computeDiscount from './utils/computeDiscount';

class SubscriptionDetails extends React.Component {
  constructor(props) {
    super(props);

    this.monthlyPlansList = this.monthlyPlansList.bind(this);
    this.yearlyPlansList = this.yearlyPlansList.bind(this);
    this.mapDetails = this.mapDetails.bind(this);
    this.dataDetails = this.dataDetails.bind(this);
    this.canvassingDetails = this.canvassingDetails.bind(this);
  }

  monthlyPlansList() {
    const { monthly_items, plans } = this.props;
    const map_items = monthly_items
    .filter(item => {
      const current_plan = plans.find(p => p._id == item.plan);
      return [ 'map_national', 'map_state', 'map_city' ].includes(current_plan.type);
    });
    const data_items = monthly_items
    .filter(item => plans.find(p => p._id == item.plan).type == 'data');
    const canvassing_items = monthly_items
    .filter(item => plans.find(p => p._id == item.plan).type == 'canvassing');

    return (
      <div className='subscription-details-monthly-plans-container'>
        <h2>Monthly Plans</h2>
        <hr className='dotted short' />
        {this.mapDetails(map_items)}
        {this.dataDetails(data_items)}
        {this.canvassingDetails(canvassing_items)}
      </div>
    );
  }
  yearlyPlansList() {
    const { yearly_items, plans } = this.props;
    const map_items = yearly_items
    .filter(item => {
      const current_plan = plans.find(p => p._id == item.plan);
      return [ 'map_national', 'map_state', 'map_city' ].includes(current_plan.type);
    });
    const data_items = yearly_items
    .filter(item => plans.find(p => p._id == item.plan).type == 'data');
    const canvassing_items = yearly_items
    .filter(item => plans.find(p => p._id == item.plan).type == 'canvassing');

    return (
      <div className='subscription-details-monthly-plans-container'>
        <h2>Yearly Plans</h2>
        <hr className='dotted short' />
        {this.mapDetails(map_items)}
        {this.dataDetails(data_items)}
        {this.canvassingDetails(canvassing_items)}
      </div>
    );
  }
  calculateTotal() {
    const {
      monthly_items,
      yearly_items,
      plans,
      map_regions
    } = this.props;

    const totals = {
      monthly_totals: {
        map_city_total: 0,
        map_state_total: 0,
        map_national_total: 0,
        map_discount_total: 0,
        data_total: 0,
        canvassing_total: 0
      },
      yearly_totals: {
        map_city_total: 0,
        map_state_total: 0,
        map_national_total: 0,
        map_discount_total: 0,
        data_total: 0,
        canvassing_total: 0
      }
    };

    monthly_items.forEach(item => {
      const current_plan = plans.find(p => p._id == item.plan);
      switch(current_plan.type) {
        case 'map_city': {
          const city_regions = item.map_regions.filter(r => /^\/plans\/city.+$/i.test(r));
          totals.monthly_totals.map_city_total += +current_plan.amount * city_regions.length;
          break;
        }
        case 'map_state': {
          const state_regions = item.map_regions.filter(r => /^\/plans\/state.+$/i.test(r));
          totals.monthly_totals.map_state_total += +current_plan.amount * state_regions.length;
          break;
        }
        case 'map_national': {
          totals.monthly_totals.map_national_total += +current_plan.amount;
          break;
        }
        case 'data': {
          totals.monthly_totals.data_total += +current_plan.amount;
          break;
        }
        case 'canvassing': {
          totals.monthly_totals.canvassing_total += +current_plan.amount;
          break;
        }
      }
    });

    // ***** MAPS DISCOUNT ***** //
    if(totals.monthly_totals.map_city_total > 0 || totals.monthly_totals.map_state_total > 0) {
      const map_city_plan = plans.find(p => p.interval == 'month' && p.type == 'map_city');
      const map_state_plan = plans.find(p => p.interval == 'month' && p.type == 'map_state');
      const selected_regions = monthly_items.reduce((acc, item) => [ ...acc, ...(item.map_regions || []) ], []);
      const maps_discount = computeDiscount(selected_regions, map_city_plan, map_state_plan);
      totals.monthly_totals.map_discount_total = maps_discount;
    }

    yearly_items.forEach(item => {
      const current_plan = plans.find(p => p._id == item.plan);
      switch(current_plan.type) {
        case 'map_city': {
          const city_regions = item.map_regions.filter(r => /^\/plans\/city.+$/i.test(r));
          totals.yearly_totals.map_city_total += +current_plan.amount * city_regions.length;
          break;
        }
        case 'map_state': {
          const state_regions = item.map_regions.filter(r => /^\/plans\/state.+$/i.test(r));
          totals.yearly_totals.map_state_total += +current_plan.amount * state_regions.length;
          break;
        }
        case 'map_national': {
          totals.yearly_totals.map_national_total += +current_plan.amount;
          break;
        }
        case 'data': {
          totals.yearly_totals.data_total += +current_plan.amount;
          break;
        }
        case 'canvassing': {
          totals.yearly_totals.canvassing_total += +current_plan.amount;
          break;
        }
      }
    });

    // ***** MAPS DISCOUNT ***** //
    if(totals.yearly_totals.map_city_total > 0 || totals.yearly_totals.map_state_total > 0) {
      const map_city_plan = plans.find(p => p.interval == 'year' && p.type == 'map_city');
      const map_state_plan = plans.find(p => p.interval == 'year' && p.type == 'map_state');
      const selected_regions = monthly_items.reduce((acc, item) => [ ...acc, ...(item.map_regions || []) ], []);
      const maps_discount = computeDiscount(selected_regions, map_city_plan, map_state_plan);
      totals.yearly_totals.map_discount_total = maps_discount;
    }

    return totals;
  }
  mapDetails(map_items) {
    if(map_items.length > 0) {
      const { yearly_totals, monthly_totals } = this.calculateTotal();

      const customComponent = props => (
        <div>
          {map_items.map(item => {
            const current_plan = props.plans.find(p => p._id == item.plan);
            const amount = current_plan.interval == 'year' ?
            yearly_totals[`${current_plan.type}_total`] :
            monthly_totals[`${current_plan.type}_total`];

            return (
              <div key={current_plan._id}>
                <h4 className='text-uppercase'>{`${current_plan.name} | $${(+amount / 100).toFixed(2)}`}</h4>
                {current_plan.type != 'map_national' ? (
                  <div>
                    <ListGroup>
                      {item.map_regions.map(region => {
                        const current_region = props.map_regions.find(r => r.path == region);
                        return <ListGroupItem key={region}>{current_region.name}</ListGroupItem>
                      })}
                    </ListGroup>
                  </div>
                ) : null}
              </div>
            );
          })}
          {(() => {
            const map_discount_total = monthly_totals.map_discount_total || yearly_totals.map_discount_total;
            const map_state_total = monthly_totals.map_state_total || yearly_totals.map_state_total;
            const map_city_total = monthly_totals.map_city_total || yearly_totals.map_city_total;

            if(map_discount_total > 0) {
              return (
                <div className='subscription-details-map-price-container'>
                  <div className='sentence-fragment'>
                    <h4 className='text-uppercase'>Total =<span>{' '}</span></h4>
                  </div>
                  <div className='sentence-fragment'>
                    <h4 className='text-uppercase'>${((map_city_total + map_state_total) / 100).toFixed(2)}<span>{' '}</span></h4>
                  </div>
                  <div className='sentence-fragment'>
                    <h4 className='text-uppercase'>-<span>{' '}</span></h4>
                  </div>
                  <div className='sentence-fragment'>
                    <h6>Discount</h6>
                    <h4 className='text-uppercase'>${(map_discount_total / 100).toFixed(2)}<span>{' '}</span></h4>
                  </div>
                  <div className='sentence-fragment'>
                    <h4 className='text-uppercase'>={` $${((map_city_total + map_state_total - map_discount_total) / 100).toFixed(2)}`}</h4>
                  </div>
                </div>
              )
            }
          })()}
        </div>
      );

      return (
        <IconBoxPanel
          container_class_name='subscription-details-icon-box-container'
          show_icon hide_title
          icon_class='fa fa-globe'
          CustomComponent={customComponent(this.props)}
        />
      );
    }
    else {
      return null;
    }
  }
  dataDetails(data_items) {
    const customComponent = props => {
      return data_items.map(item => {
        const current_plan = props.plans.find(p => p._id == item.plan);
        return (
          <div key={current_plan._id}>
            <h4 className='text-uppercase'>
              {`${current_plan.name} | $${(+current_plan.amount / 100).toFixed(2)}`}
            </h4>
          </div>
        );
      });
    }
    if(data_items.length > 0) {
      return (
        <IconBoxPanel
          container_class_name='subscription-details-icon-box-container'
          show_icon hide_title
          icon_class='fa fa-database'
          CustomComponent={customComponent(this.props)}
        />
      )
    }
  }
  canvassingDetails(canvassing_items) {
    const customComponent = props => {
      return canvassing_items.map(item => {
        const current_plan = props.plans.find(p => p._id == item.plan);
        return (
          <div key={item.plan}>
            <h4
              className='text-uppercase'
              key={current_plan._id}
              >
              {`${current_plan.name} | $${((+current_plan.amount * +item.quantity) / 100).toFixed(2)} | Users: ${item.quantity}`}
            </h4>
          </div>
        );
      });
    }
    if(canvassing_items.length > 0) {
      return (
        <IconBoxPanel
          container_class_name='subscription-details-icon-box-container'
          show_icon hide_title
          icon_class='fa fa-map-marker'
          CustomComponent={customComponent(this.props)}
        />
      )
    }
  }

  render() {
    const { monthly_items, yearly_items, plans } = this.props;
    const map_items = [ ...monthly_items, ...yearly_items ]
    .filter(item => {
      const current_plan = plans.find(p => p._id == item.plan);
      return [ 'map_national', 'map_state', 'map_city' ].includes(current_plan.type);
    });
    const data_items = [ ...monthly_items, ...yearly_items ]
    .filter(item => plans.find(p => p._id == item.plan).type == 'data');
    const canvassing_items = [ ...monthly_items, ...yearly_items ]
    .filter(item => plans.find(p => p._id == item.plan).type == 'canvassing');
    return (
      <div className='subscription-details-container'>
        {monthly_items.length > 0 && yearly_items.length > 0 ? (
          <Row>
            <Col md={6} xs={6}>
              <Panel>{this.yearlyPlansList()}</Panel>
            </Col>
            <Col md={6} xs={6}>
              <Panel>{this.monthlyPlansList()}</Panel>
            </Col>
          </Row>
        ) : monthly_items.length > 0 ? (
          <Row>
            <Col md={12} xs={12}>
              <Panel>{this.monthlyPlansList()}</Panel>
            </Col>
          </Row>
        ) : yearly_items.length > 0 ? (
          <Row>
            <Col md={12} xs={12}>
              <Panel>{this.yearlyPlansList()}</Panel>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={12} xs={12}>
              <p>No Plans Selected - $0</p>
            </Col>
          </Row>
        )}
      </div>
    )
  }
}

export default SubscriptionDetails;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/subscription-details.js